(function () {
  var DURATION_MS = 360;
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getPanel(item) {
    return item.querySelector('.faq__content');
  }

  function clearTransition(panel) {
    panel.style.transition = '';
  }

  function setSettledState(panel, open) {
    if (!panel) return;
    clearTransition(panel);
    if (open) {
      panel.style.height = 'auto';
      panel.style.opacity = '1';
    } else {
      panel.style.height = '0px';
      panel.style.opacity = '0';
    }
  }

  function animatePanel(panel, open, onComplete) {
    if (!panel) {
      if (onComplete) onComplete();
      return;
    }

    if (prefersReducedMotion) {
      setSettledState(panel, open);
      if (onComplete) onComplete();
      return;
    }

    var startHeight = panel.getBoundingClientRect().height;
    var endHeight = open ? panel.scrollHeight : 0;

    panel.style.height = startHeight + 'px';
    panel.style.opacity = open ? '0' : '1';
    // Force layout so the browser registers the starting height.
    panel.getBoundingClientRect();

    panel.style.transition =
      'height ' + DURATION_MS + 'ms ' + EASING + ', opacity ' + DURATION_MS + 'ms ' + EASING;
    panel.style.height = endHeight + 'px';
    panel.style.opacity = open ? '1' : '0';

    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      panel.removeEventListener('transitionend', onTransitionEnd);
      window.clearTimeout(fallbackTimer);
      setSettledState(panel, open);
      if (onComplete) onComplete();
    };

    var onTransitionEnd = function (event) {
      if (event.target !== panel || event.propertyName !== 'height') return;
      finish();
    };

    panel.addEventListener('transitionend', onTransitionEnd);
    var fallbackTimer = window.setTimeout(finish, DURATION_MS + 80);
  }

  function closeItem(item, animate) {
    if (!item.open || item.dataset.faqAnimating === 'true') return;

    var panel = getPanel(item);
    if (!animate || prefersReducedMotion) {
      item.open = false;
      setSettledState(panel, false);
      return;
    }

    item.dataset.faqAnimating = 'true';
    if (panel) {
      panel.style.height = panel.scrollHeight + 'px';
      panel.getBoundingClientRect();
    }

    animatePanel(panel, false, function () {
      item.open = false;
      delete item.dataset.faqAnimating;
    });
  }

  function openItem(item, animate) {
    if (item.open || item.dataset.faqAnimating === 'true') return;

    var panel = getPanel(item);
    item.open = true;

    if (!animate || prefersReducedMotion) {
      setSettledState(panel, true);
      return;
    }

    item.dataset.faqAnimating = 'true';
    if (panel) {
      panel.style.height = '0px';
      panel.style.opacity = '0';
    }

    animatePanel(panel, true, function () {
      delete item.dataset.faqAnimating;
    });
  }

  function initFaqSection(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';
    root.classList.add('faq--enhanced');

    var items = Array.prototype.slice.call(root.querySelectorAll('details.faq__item'));

    items.forEach(function (item) {
      setSettledState(getPanel(item), item.open);

      var summary = item.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (item.open) {
          closeItem(item, true);
          return;
        }

        items.forEach(function (other) {
          if (other !== item && other.open) {
            closeItem(other, true);
          }
        });

        openItem(item, true);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.faq[data-faq-section]').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.faq[data-faq-section]');
    if (root) {
      delete root.dataset.faqReady;
      initFaqSection(root);
    }
  });
})();
